import { saveAs } from 'file-saver';
import { trackerApi } from "../../../core/api/TrackerApi";
import { useMutationCommand } from '../../../core/components/helpers/queryHelper';

export interface GenerateSeedDto {
    seasonId: string,
    downloadZpf: boolean
}

const generateSeed = async (props: GenerateSeedDto) => {

    const url = '/oot/generator/generate-seed'

    var seedId = await trackerApi.DownloadFilePostAsync(url, props).then(response => {

        const filename: string = response.headers["content-disposition"].split('filename=')[1].split(';')[0];

        if (props.downloadZpf)
            saveAs(response.data, filename)

        return filename.split("_").reverse()[0].replace(".zpf", "");
    });


    return seedId;
}

export const useMutateGenerateSeed = () => {

    let mutation = useMutationCommand(generateSeed, "Seed Generation");

    return mutation;
}


export interface PatchRomDto {
    rom: File,
    seedId: number | string
}

const patchRom = async (values: PatchRomDto) => {
    const url = '/oot/generator/patch-rom?seedId=' + values.seedId
    await trackerApi.UploadFileWithResultFileAsync(values.rom, "rom", url).then(response => {

        const filename: string = response.headers["content-disposition"].split('filename=')[1].split(';')[0];

        saveAs(response.data, filename)
    })
}

export const useMutatePatchRom = () => {
    let mutation = useMutationCommand(patchRom, "Patch Rom");

    return mutation;
}